<template>
    <div class="shopping-cart-summary">
        <div class="cart-summary" :class="{'cart-summary_close':isMobile}">

            <v-dialog v-model="isSubmit" width="500" persistent class="cart-summary-confirm-order">
            <SummaryV2 
            :isSubmit="isSubmit"
            :confirm="confirmOrder"
            :cancel="cancelOrder"
            :store="this.store1"
            :order="this.order"
            :payMethod="this.payMethod" />
            </v-dialog>
        
            <div class="cart-summary-main">
                <div class="cart-summary-form">
                    <div class="cart-summary-warning-wrapper">
                        <div class="box-warning" :class="{'box-warning_active': isNameError}">
                            <div class="box-triangle"></div>
                            <h6>The name is required!</h6>
                        </div>
                        <van-cell-group>
                            <div class="flex flex-center padd5px user-nav-name pl-2 py-2 cart-summary-form-name">
                            <div class="cart-summary-form-name_text">Name *</div>
                            <input ref="receiver_name"  v-model="receiver_name" placeholder="Your name" class="inputfocus cart-summary-form-name_input"/>
                            </div>
                        </van-cell-group>
                    </div>
                
                    <div class="cart-summary-warning-wrapper">
                        <div class="box-warning" :class="{'box-warning_active': isPhoneError || invalidNoPhone}">
                            <div class="box-triangle"></div>
                            <h6 v-if="isPhoneError">The mobile phone number is required!</h6>
                            <h6 v-else>The mobile phone number is invalid!</h6>
                        </div>
                        <van-cell-group>
                            <div class="flex flex-center padd5px user-nav-name pl-2 py-2 cart-summary-form-contact">
                                <div class="cart-summary-form-contact_text">Mobile No. *</div>
                                <vue-tel-input 
                                ref="receiver_phone" 
                                :onlyCountries="phoneCountries" 
                                :required="true" 
                                class="contact-phone bgwhite" 
                                v-model="(receiver_phone)" 
                                defaultCountry='MY'
                                autocomplete="off"
                                mode='international'
                                @validate="validateMobileInput" 
                                style="flex:1" />
                                <div class="van-field__right-icon">
                                <van-icon name="success" color="green" v-if="isMobileValid" />
                                <van-icon name="cross" color="red" v-if="!isMobileValid" />
                                </div>
                            </div>
                        </van-cell-group>
                    </div>

                    <van-cell-group>
                        <div class="flex flex-center padd5px user-nav-name pl-2 py-2 cart-summary-form-email">
                            <div class="cart-summary-form-email_text">Email</div>
                            <input ref="email" v-model="email" placeholder="abc@example.com" class="cart-summary-form-email_input" />
                        </div>
                    </van-cell-group>

                    <van-cell-group v-if="(isTakeaway || isDelivery) && isLogin">
                        <div class="padd5px">
                            <div class="padd5px">
                                <van-checkbox class="checkbox-mobile-label" icon-size="12px" v-model="checkbox_mobile_value" shape="square">{{checkbox_mobile_label}}</van-checkbox>
                            </div>
                        </div>
                    </van-cell-group>
                    <van-cell-group v-if="(isTakeaway || isDelivery) && isExpand">
                        <div class="padd5px cart-summary-form-notice">
                            <div class="padd5px">
                                <div style="font-size:11px">
                                    <div class="import_text1">{{import_text1}}</div>
                                    <div class="import_text2">{{import_text2}}</div>
                                </div>
                            </div>
                        </div>
                    </van-cell-group>
                </div>

                <div class="cart-takeaway" v-if="store1.is_schedule == 1 || store1.is_24_hours_operation == 1">
                    <div class="flex justify-between cart-takeway-header">
                        <div class="cart-takeaway-header-wrapper">
                            <span v-if="!showtimeSchedule" class="cart-takeaway-header-text"> Pickup Time (At Shop)</span> 
                            <span v-if="showtimeSchedule" class="cart-takeaway-header-text-small" > Pickup Time (At Shop)</span> 
                            <span v-if="showtimeSchedule" class="ml-1 pre-order">PRE-ORDER</span>
                        </div>
                        <v-btn class="px-0 cart-takeaway-btn-back" text x-small @click="SetTimeNow" v-if="!scheduleType && showtimeSchedule">
                            <v-icon size="16" class="buttonIcon">
                            {{ icons.mdiArrowLeft}} 
                        </v-icon>
                        <span class="cart-takeaway-btn-back--text">Back</span>
                        </v-btn>
                    </div>
                    <div class="cart-takeaway-schedule-wrapper">
                        <div class="cart-takeaway-select-time" :class="{'cart-takeaway-select-time__isActive': showtimeSchedule}">
                            <div class="flex mt-2 cart-takeaway-select-time-btn" @click="ShowTimeSchedule">
                            <div class="flex justify-between px-2 py-1 cart-takeaway-select-time-btn--text">
                                <!-- <span v-if="order.schedule.type" class="cart-takeaway-select-time-btn--text_pre">PRE-ORDER</span> -->
                                <span class="cart-takeaway-select-time-btn--text_now">NOW / ASAP</span>
                                    <v-icon class="buttonIcon" small>
                                        {{icons.mdiTimer}}
                                    </v-icon>                    
                            </div>
                            <div class="cart-takeaway-select-time-btn--icon">
                                <v-icon class="whiteIcon" small>
                                    {{icons.mdiArrowRight }}
                                </v-icon>
                            </div>
                        </div>

                        </div>
                
                        <div class="cart-takeaway-time" :class="{'cart-takeaway__isActive' : showtimeSchedule}"> 
                            <div class="flex">
                                <div>
                                <DateTimePickerV2 
                                    :date="this.order.schedule.datetime"
                                    :minDate="this.minDateAfterValidate"
                                    :confirm="confirmFn"
                                    :businessHours="this.businessHours"
                                    :holiday="this.holiday"
                                    onlyDate
                                    :evtEnabledButtonCheckout ="enabledButtonCheckout"
                                    :isShowtimeSchedule="showtimeSchedule"
                                />
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>

                <div class="cart-summary-container" style="position:relative">
                    <div @click="setExpand" class="button-expand-detail bg-main" :class="{'button-expand-detail_active':isExpand}">
                    {{ isExpand ? 'Less detail' : 'More detail'}}
                    <v-icon class="button-expand-detail-icon" :class="{'button-expand-detail-icon_active':isExpand}" color="white">{{icons.mdiMenuDown}}</v-icon>
                    </div>

                    <div class="expand-detail" :class="{'expand-detail_active': isExpand}">
                        <div class="flex mb-2" style="font-size:14px">
                            <div v-if="showRemark || !showCoupon" class="cart-order_remark"  :class="{'remark_active':showRemark}">
                                <div @click="ShowReMark" class="show-remark-btn">
                                    <v-icon size="15" class="mr-1 buttonIcon">
                                    {{ icons.mdiPencilOutline }}
                                    </v-icon>
                                    Order's Remark
                                </div>
                                <div v-if="showRemark" class="show-remark">
                                    <van-cell-group>
                                        <van-field v-if="!store1.isEpointEnabled" v-model="order.remark" rows="3" autosize type="textarea" placeholder="Order's Remark"  class="show-remark-textarea" />
                                        <van-field v-if="store1.isEpointEnabled" v-model="order.remark" rows="3" autosize type="textarea" placeholder="Order's Remark  (max 19 characters)" maxlength="19"  class="show-remark-textarea" />
                                    </van-cell-group>

                                    <v-btn @click="ShowReMark" x-small tile color="primary" class="show-remark-btn-save">
                                        save
                                    </v-btn>
                                </div>
                            </div>
                            <div class="cart-order-coupon" :class="{'cart-order-coupon_active': showCoupon}" v-if="!showRemark || showCoupon">
                                <div @click="ShowCoupon" class="flex my-2 order-coupon-btn">

                                    <v-icon v-if="!showCoupon" size="18" class="mr-1 buttonIcon">
                                        {{icons.mdiLabelPercentOutline}}
                                    </v-icon>
                                    <v-icon v-if="showCoupon" size="18" class="ml-3 mr-1 buttonIcon">
                                        {{ icons.mdiArrowLeft }}
                                    </v-icon>
                                    {{ showCoupon ? 'back': 'Coupon' }}

                                </div>
                                <div v-if="showCoupon" class="order-coupon-show">
                                    <van-cell :title="'Coupons'" is-link :value="coupon_code || '0 coupons available'" @click="popupCoupon = coupon_list.length" class="order-coupon-text" />
                                    <van-popup v-model="popupCoupon" position="bottom" :style="{ height: '50%' }">
                                    <div class="flex justify-between ">
                                        <van-button type="danger" size="mini" @click="cleanCoupon">Clean</van-button>
                                        <van-button type="info" size="mini" @click="applyCoupon">Okey</van-button>
                                    </div>
                                    <van-radio-group v-model="coupon_code">
                                        <van-cell-group>
                                        <van-cell v-for="itemCoupon in coupon_list" :key="itemCoupon" :title="itemCoupon.title" clickable @click="coupon_code = itemCoupon.name">
                                            <van-radio slot="right-icon" :name="itemCoupon.name" />
                                        </van-cell>
                                        </van-cell-group>
                                    </van-radio-group>
                                    </van-popup>
                                </div>
                            </div>
                        </div>

                        <div class="terms-privacy" >
                            <div @click="ShowTerms" class="terms-privacy-subhead">
                                <div>
                                    <span>Terms and Privacy Policy</span>
                                </div>
                                <div>
                                    <v-icon class="buttonIcon">
                                            {{icons.mdiMenuDown}}
                                    </v-icon>
                                </div>
                            </div>
                            <div v-if="showTerms" class="terms-privacy-content">
                                <van-checkbox icon-size="12px" v-model="isTermsAccepted" shape="square">
                                <span>By placing this order, I agree to the {{FASTORDER}} </span>
                                <span class="terms-privacy-link" @click="funTC(`${FASTORDER_BUSINESS_URL}/terms-conditions/`)">Terms & Condition</span> <span>and </span>
                                <span class="terms-privacy-link" @click="funTC(`${FASTORDER_BUSINESS_URL}/privacy-policy/`)">Privacy Policy</span>
                            </van-checkbox>
                            </div>
                        </div>

                        <div class="cart-payment">
                            <div class="flex justify-between cart-payment-header">
                                <div>Payment Summary</div>
                                <div class="cart-payment-btn-dropdown" @click="hidePayDetail">
                                    View Details
                                    <div class="cart-payment-icon" :class="{'cart-payment-icon__isActive': !isHide}">
                                    <v-icon class="buttonIcon">
                                        {{icons.mdiMenuDown}}
                                    </v-icon>
                                    </div>
                                </div>
                            </div>

                            <div v-if="!isHide" class="cart-payment-detail"> 
                                <div v-for="(item, index) in cart.summmary" :key="index">
                                    <div class="flex justify-between" style="font-size:13px">
                                        <div>{{ item.label }} <span v-if="item.type=='promo' && isCoupon">({{coupon_code}})</span> </div>
                                        <div>RM {{ item.text }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                <div class="cart-payment">
                    <div class="flex justify-between cart-payment-total">
                        <div>Total Payment</div>
                        <div>RM {{ cartTotal }}</div>
                    </div>
                    <div class="cart-checkout">
                        <v-btn @click="validation" class="cart-checkout-btn bg-main" :disabled="checkoutDisabled">
                            <span v-if="!isLoading" class="cart-checkout-text">checkout</span>

                            <div v-else class="cart-checkout-text mx-auto">
                              <v-progress-circular
                                :width="1"
                                size="15"
                                color="white"
                                indeterminate
                                class="mr-2"
                              ></v-progress-circular>
                              Waiting...
                            </div>
                        </v-btn>
                    </div>
                </div>
            </div>

    <div class="confirm-phone-overlay">
        <v-dialog v-model="show" width="400" v-if="isTakeaway" persistent>
            <div class="flex justify-center confirm-phone-overlay-main">
                <div style="text-align:center">
                    <div>Are you confirm your mobile phone number:</div>
                    <div class="confirm-phone-overlay_receiver-phone">{{ receiver_phone }}</div>
                    <div>You will receive sms for order status update and verification purpose.</div>

                    <div class="flex flex-center padd5px btn-action mt-5 " style="justify-content:space-around">
                        <div class="confirm-place-order" @click="confirmPlaceOrder">
                            <div>
                                <van-loading v-if="isSubmit" color="#ee0a24" size="18" />
                                <div class="confirm-place-order-btn-save"> Confirm </div>
                            </div>
                        </div>
                        <div @click="noChangeit" style="cursor:pointer">
                            Change it / Cancel
                        </div>
                    </div>
                </div>
            </div>
        </v-dialog>
    </div>

        <v-dialog v-model="overlay" width="1" style="z-index:4100;" persistent hide-overlay>
            <v-overlay>
            <v-progress-circular
                indeterminate
                size="64"
            ></v-progress-circular>
            </v-overlay>
        </v-dialog>
    </div>

    </div>

</template>
<script>
import DateTimePickerV2 from './DateTimePickerV2.vue'
import SummaryV2 from './SummaryV2.vue'
import { Toast } from 'vant';
import { isNumber } from 'util'
import {  indexPage,cartPage, addToOrder, checkHistoryExist, validateBusinessAndHoliday } from '@/api/api'
import { cartMixin } from '@/mixins/cartMixin'
import { mainMixin } from '@/mixins/mainMixin'
import { mapGetters, mapActions } from 'vuex'
import { parse,stringify } from 'querystring'
import moment from 'moment'
import { FASTORDER,FASTORDER_MY,FASTORDER_BUSINESS_URL } from '@/constants'
import { 
    mdiDotsVertical,
    mdiPencilOutline,
    mdiLabelPercentOutline ,
    mdiMenuDown ,
    mdiCrosshairsGps ,
    mdiArrowRight,
    mdiArrowLeft,
    mdiTimer,
    mdiChevronRight,
    mdiChevronLeft,
    mdiCartVariant,
    mdiPlus
} from '@mdi/js';

export default {
    components: {
        DateTimePickerV2 , 
        SummaryV2,
    },
    props: {
        myCartSubTotal: {
            type: Number,
            default:0.00
        },
        isMobile: {
            type: Boolean,
            default:false
        },
        
    },
    data() {
        return {
        FASTORDER,
        FASTORDER_MY,
        FASTORDER_BUSINESS_URL,
        icons:{
            mdiDotsVertical ,
            mdiPencilOutline ,
            mdiLabelPercentOutline,
            mdiMenuDown,
            mdiCrosshairsGps ,
            mdiArrowRight,
            mdiArrowLeft,
            mdiTimer,
            mdiChevronRight,
            mdiChevronLeft,
            mdiCartVariant,
            mdiPlus
        },
        isLoading: false,
        checkoutDisabled: false,
        clearTime:null,
        invalidNoPhone: false,
        isPhoneError:false,
        isNameError:false,
        minDateAfterValidate:new Date(),
        isExpand:false,
        showtimeSchedule:false,
        showCoupon:false,
        showRemark:false,
        showTerms:false,
        isHide: true,
        isRequest: false,
        overlay: false,
        isMobileValid:false,
        receiver_name: '',
        receiver_phone: '',
        email: '',
        phoneCountries: ['MY', 'SG', 'ID'],
        isTermsAccepted: true,
        checkbox_mobile_value: 0,
        checkbox_mobile_label: 'Update this mobile number into my profile.',
        import_text1: '* Important: ',
        import_text2: 'You will receive sms for order status update and verification purpose.',
        goodsList: [],
        cartTotal: 0.00,
        carts: [],
        cart: {
            summmary: []
        },
        isCoupon: false,
        popupCoupon: false,
        coupon_code: '',
        coupon_list: [],
        membership_id: '',
        reqUrl: false,
        show:false,
        isTakeaway: false,
        isDelivery: false,
        isSchedule: false,
        isWeixin: false,
        is_required_address_takeaway: false,
        isLogin: false,
        hasHistoryOrder: false, //是否存在历史订单
        ssouser: false, //sso.user 信息
        dish_datetime: '',
        dish_datetime1: '',
        begintime: '',
        endtime: '',
        begintime1: '',
        endtime1: '',
        begintime2: '',
        endtime2: '',
        showDishDatetime: false,
        dishDatetime: new Date(),
        addedTime: 0,
        sso: {},
        lalamove: {},
        lalamove_service_type: '', // 配送外卖时的交通类型, 页面中暂时没有用到
        isQuotation: false, //判断是否已经报价
        minDate: '',
        isSubmit: false,
        datetimePicker: {
            title: 'Schedule Date & Time',
            confirmText: 'Confirm',
            cancelText: 'Cancel'
        },
        store: {},
        store1: {
            title: '',
            logo: '',
            location: {
            address: '',
            lat: 0,
            lng: 0
            },
            is_rest: 0,
            is_show: 0,
            is_schedule: 0,
            is_24_hours_operation:0,
            readyInMinute: 0,
            isNameRequired: false,
            isContactRequired: false,
            isEmailRequired: false,
            isEpointEnabled: false
        },
        businessHours: {},
        holiday: {},
        payMethod: {},
        storeInfo: {},
        scheduleType: false,
        table: {},
        order: {
            isDineIn: false,
            isTakeaway: true,
            isDelivery: false,
            user: {
            name: '',
            contact: '',
            email: '',
            },
            address: {
            name: '',
            address1: '',
            address2: '',
            address3: '',
            city: '',
            state: '',
            country: '',
            zip: '',
            lat: '',
            lng: ''
            },
            schedule: {
            type: false,
            datetime: new Date()
            },
            remark: ''
        },
        show2:false, //goodattr
        qty: 0,
        isRequired:false,
        timeVal: "",
        currentGood: null,
        currentAttr: null,
        isSelectedAttr: false,
        attrPopupHeight: "100%",
        currentAttrTotal: 0.0,
        }
    },
    mixins: [cartMixin,mainMixin],
    computed: {
        ...mapGetters(["delivery_current_storeinfo", "user_islogin", "user_detail", "cart_qty"]),
    },
    watch: { 
        myCartSubTotal: function() {
            this.get_data()
        },
        deep: true
    },
    created() {
        this.get_data();
        this.resolveDateTime();
        if (this.delivery_current_address && this.delivery_current_address.address_id != undefined) {
        this.delivery_current_address = null
        }

    },
    methods: {
        ...mapActions({
        saveCurrentStoreInfo: "delivery/settingCurrentStoreInfo",

        }),
        showWarning(error_type){
            if(error_type === 'name'){
            this.isPhoneError = false
                this.isNameError =true
                this.invalidNoPhone = false
                this.clearTime= setTimeout(()=>{
                    this.isNameError = false
                },4000)
            }else if(error_type === 'phone'){
                this.isNameError = false
                this.isPhoneError =true
                this.invalidNoPhone = false
                this.clearTime= setTimeout(()=>{
                    this.isPhoneError = false
                },4000)
            }else if(error_type === 'invalid number'){
            this.isNameError = false
                this.isPhoneError =false
                this.invalidNoPhone = true
                this.clearTime= setTimeout(()=>{
                    this.invalidNoPhone = false
                },4000)
            }
            this.clearTime
        },
        validateMobileInput({ number, isValid, country }) {
        this.isMobileValid = isValid;
        },

        setExpand(){
        this.isExpand = !this.isExpand
        this.isHide = true
        this.showTerms = false
        this.showCoupon= false
        this.showRemark = false
        },
        SetTimeNow(){
            this.showtimeSchedule = false
            this.order.schedule.type =false;
            sessionStorage.removeItem('select_time')
            this.isScheduleEnabled()
        },
        enabledButtonCheckout(value){
            this.checkoutDisabled= value
        },
        ShowTimeSchedule(){
            if(this.isSchedule){
                this.checkoutDisabled = true
                this.order.schedule.type= true
                this.showtimeSchedule = true
                this.isScheduleEnabled() 
            }
        },
        ShowCoupon(){
            this.showCoupon = !this.showCoupon
            this.isHide = true
            this.showTerms = false
        },
        ShowReMark(){
            this.showRemark= !this.showRemark
            this.isHide = true
            this.showTerms = false
        },
        ShowTerms(){
            this.showTerms= !this.showTerms
            this.showRemark= false
            this.showCoupon =false
            this.isHide = true
        }, 
        hidePayDetail(){
            this.isHide = !this.isHide
            this.showRemark= false
            this.showCoupon = false
            this.showTerms = false
        }, 
        showScheduleDateTimePicker() {
        this.showDishDatetime = !this.showDishDatetime;
        },
        isScheduleEnabled() {
        this.order.schedule.type != this.order.schedule.type;
        if(this.order.schedule.type) {
            this.setMinDate();
            this.order.schedule.datetime = this.minDate;
        } else {
            this.order.schedule.datetime = new Date();
        }
        this.resolveDateTime();
        },

        setMinDate() {
        let currDT = (new Date()).getTime();
        let minDate = new Date(currDT + (31 * 60 * 1000));

        if(minDate.getMinutes()%10 > 0) {
            minDate.setMinutes(minDate.getMinutes() + (10-(minDate.getMinutes()%10)));
        }
        this.minDate = minDate
        console.log('min date =>>', this.minDate)
        this.checkBusinessHour(this.minDate)
        },
    checkBusinessHour(mindate){
        let minDate = new Date(mindate);
        console.log('minDate from checkBusinessHour', minDate)

        if(minDate.getMinutes()%10 > 0) {
            minDate.setMinutes(minDate.getMinutes() + (10-(minDate.getMinutes()%10)));
        }
        if (this.addedTime == 0){
            for (let i=0;i<this.goodsList.length;i++){
            if (this.goodsList[i].preparation_time != undefined){
                var maxPrepTime = this.goodsList[i].preparation_time
                if (i > 0){
                if (this.goodsList[i].preparation_time > this.goodsList[i-1].preparation_time){
                    maxPrepTime = this.goodsList[i].preparation_time
                }
                }
            }
            }
            if (maxPrepTime > 30){
            minDate.setMinutes(mindate.getMinutes() + (maxPrepTime - 30))
            if(minDate.getMinutes()%10 > 0) {
                minDate.setMinutes(minDate.getMinutes() + (10-(minDate.getMinutes()%10)));
            }
            this.minDate = minDate
            }
            this.addedTime = 1;
            minDate = this.minDate
        }

        let businesshours = this.businessHours.data
        //let mindate = new Date(minDate)
        let daysArrayOpen = new Array()
        for (let i in businesshours){
            let daysInArray = Object.keys(businesshours[i])
            console.log('Business hours', businesshours[i])
            console.log('minDate day include in database',daysInArray.toString())
            daysArrayOpen.push(daysInArray.toString())
        }
        for (let i in businesshours){
            for (let j in businesshours[i]){
                let daysInNumber = this.getDaysNumber(j)
                let maxDataToday = businesshours[i][j].length - 1
                let days = new Array
                for(let i=0;i<7;i++){
                days[i] = this.getDays(minDate.getDay())
                let daysValidate = daysArrayOpen.includes(days[i])
                console.log('daysValidation open',daysValidate) 
                if (!daysValidate){
                    minDate.setDate(minDate.getDate() + 1)
                    minDate.setHours(0)
                    minDate.setMinutes(0)
                } else {
                    break;
                }
                }
                if (minDate.getDay() == daysInNumber){
                console.log('mindate details', minDate + 'And daysInNumber ' , daysInNumber)
                let timeTodayLength = businesshours[i][j].length
                for (let k in businesshours[i][j]){
                    console.log('k value ',k + ' and length of data for today ', businesshours[i][j].length)
                    let hourStartString = businesshours[i][j][k]['start'].toString().padStart(4,"0")
                    let hourEndString = businesshours[i][j][k]['end'].toString().padStart(4,"0")
                    let hourStart = Number(hourStartString.substring(0,2))
                    let hourEnd = Number(hourEndString.substring(0,2))
                    console.log('Hour start for the day ', hourStartString + ' Hour end for the day ', hourEndString)
                    if (minDate.getHours() > hourStart && minDate.getHours() < hourEnd){
                    console.log('If in between hourStart & hourEnd >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                    this.minDate = minDate
                    this.order.schedule.datetime = this.minDate
                    break;
                    } else if (minDate.getHours() == hourStart){
                        if (minDate.getMinutes() >= Number(hourStartString.substring(2,4))){
                        console.log('Min Date is in operation hour', minDate)
                        this.minDate = minDate
                        this.order.schedule.datetime = this.minDate
                        break;
                        } else {
                        console.log('Minute for hour start', minDate.getMinutes())
                        console.log('Min date is out operation hour in minutes', minDate + ' hourStart = ', hourStartString + ' hourEnd = ' , hourEndString)
                        minDate.setDate(minDate.getDate())
                        minDate.setMinutes(Number(hourStartString.substring(2,4)))
                        this.minDate = minDate
                        this.order.schedule.datetime = this.minDate
                        break;
                        }
                    } else if(minDate.getHours() == hourEnd){
                        if (minDate.getMinutes() <= Number(hourEndString.substring(2,4))){
                        this.minDate = minDate
                        this.order.schedule.datetime = this.minDate
                        break;
                        } else {
                        if (k == maxDataToday){
                            minDate.setDate(minDate.getDate() + 1)
                            minDate.setHours(0)
                            minDate.setMinutes(0)
                            console.log('End of the day for business hours', k)
                            break;
                        } else {
                            continue;
                        }
                        }
                    } else if (minDate.getHours() > hourEnd){
                    console.log('If more than hourEnd >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                    console.log('value of k ', k + ' value of maxDataToday ', maxDataToday)
                        if (k == maxDataToday){
                        minDate.setDate(minDate.getDate() + 1)
                        minDate.setHours(0)
                        minDate.setMinutes(0)
                        console.log('End of the day for business hours', k)
                        break;
                        } else {
                        continue;
                        }
                    } else {
                        if(timeTodayLength == 1){
                        console.log('If less than hourStart or the same >>> '+' minDate details ', minDate + ' hourEnding', hourEndString)
                        minDate.setDate(minDate.getDate())
                        minDate.setHours(hourStart)
                        minDate.setMinutes(Number(hourStartString.substring(2,4)))
                        this.minDate = minDate
                        this.order.schedule.datetime = this.minDate
                        console.log('Min Date is out of operation hour and change to the nearest ', hourStart + ' mindate Hours>> ', minDate.getHours())
                    } else {
                        console.log('timeTodayLength',timeTodayLength)
                        console.log('minDate if less than hourStart',minDate,' hourstart',hourStart, ' hourstartstring',hourStartString)
                        if (hourStart < minDate.getHours()){
                        continue;
                        } else {
                        minDate.setDate(minDate.getDate())
                        minDate.setHours(hourStart)
                        minDate.setMinutes(Number(hourStartString.substring(2,4)))
                        console.log('Mindate after change',minDate)
                        this.minDate = minDate
                        this.order.schedule.datetime = this.minDate
                        break;
                        }
                    }
                    }
                }
                }
            }
            }
            console.log('minDate after business hours validation', this.minDate)
            this.minDateAfterValidate = this.minDate

            let holiday = this.holiday.data
            let dateMin = new Date(this.minDate)
            for (let i in holiday){
            for (let j in holiday[i]){
                let dateHoliday = new Date(j);
                if (dateMin.getFullYear() == dateHoliday.getFullYear()){
                if (dateMin.getMonth() == dateHoliday.getMonth()){
                    if (dateMin.getDate() == dateHoliday.getDate()){
                    console.log('dateMin data ', dateMin + ' dateHoliday data ', dateHoliday)
                    for (let k in holiday[i][j]){
                        let hourStartString = holiday[i][j][k]['start'].toString().padStart(4,"0")
                        let hourEndString = holiday[i][j][k]['end'].toString().padStart(4,"0")
                        let hourStart = Number(hourStartString.substring(0,2))
                        let hourEnd = Number(hourEndString.substring(0,2))
                        console.log('Hour start holiday ', hourStartString + ' hour end holiday ', hourEndString)
                        if (dateMin.getHours() > hourStart && dateMin.getHours() < hourEnd){
                        this.minDate.setHours(hourEnd)
                        this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                        this.order.schedule.datetime = this.minDate
                        console.log('minDate after holiday validation', this.minDate);
                        this.checkBusinessHour(this.minDate)
                        } else if (dateMin.getHours() == hourStart){
                        if (dateMin.getMinutes() >= Number(hourStartString.substring(2,4))){
                            this.minDate.setHours(hourEnd)
                            this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                            this.order.schedule.datetime = this.minDate
                            console.log('minDate after holiday validation', this.minDate);
                            this.checkBusinessHour(this.minDate)
                        }
                        } else if (dateMin.getHours() == hourEnd){
                        if (dateMin.getMinutes() <= Number(hourEndString.substring(2,4))){
                            this.minDate.setMinutes(Number(hourEndString.substring(2,4)) + 10)
                            this.order.schedule.datetime = this.minDate
                            console.log('minDate after holiday validation', this.minDate);
                            this.checkBusinessHour(this.minDate)
                        }
                        }
                    }
                    }
                }
                }
            }
        }
        console.log('No date time change ', this.minDate)

        this.goodsList.forEach(good=>{
          let minDatePre = this.minDate
          if (good.preOrder != undefined){
            let daysPreOrder = good.preOrder.week;
            if (daysPreOrder.includes(minDatePre.getDay())){
              console.log('days for Pre Order ',daysPreOrder)
              if (good.preOrder.istime == 1){
                let startDate = new Date(good.preOrder.startdate * 1000);
                let endDate = new Date(good.preOrder.enddate * 1000);
                console.log('Item date ', startDate , ' - ' , endDate)
                if (startDate <= minDatePre && endDate >= minDatePre){
                  if (good.preOrder.begintime != "" || good.preOrder.endtime != ""){
                    console.log('Item time ',good.preOrder.begintime , ' - ' , good.preOrder.endtime)
                    let startHour = Number(good.preOrder.begintime.substring(0,2))
                    let endHour = Number(good.preOrder.endtime.substring(0,2))
                    let startMin = Number(good.preOrder.begintime.substring(3,5))
                    let endMin = Number(good.preOrder.endtime.substring(3,5))
                    console.log('start Hour => ',startHour , ' start Minute => ',startMin, ' end Hour => ',endHour, ' end Minute ',endMin)
                    if (startHour <= minDatePre.getHours() && endHour >= minDatePre.getHours()){
                      if (startHour == minDatePre.getHours() && startMin > minDatePre.getMinutes()){
                        this.minDate.setMinutes(startMin)
                        this.order.schedule.datetime = this.minDate
                        console.log('minDate after minute validation', this.minDate)
                        this.checkBusinessHour(this.minDate)
                      } else if (endHour == minDatePre.getHours() && endMin < minDatePre.getMinutes()){
                        this.minDate.setDate(minDatePre.getDate() + 1)
                        this.minDate.setHours(0)
                        this.minDate.setMinutes(0)
                        this.order.schedule.datetime = this.minDate
                        console.log('minDate after minute validation',this.minDate)
                        this.checkBusinessHour(this.minDate)
                      } else {
                        console.log('preOrder is in hour time range',minDatePre)
                      }
                    } else if (startHour > minDatePre.getHours()) {
                      this.minDate.setHours(startHour)
                      this.minDate.setMinutes(startMin)
                      this.order.schedule.datetime = this.minDate
                      console.log('preOrder less than startHour',this.minDate)
                      this.checkBusinessHour(this.minDate)
                    } else if (endHour < minDatePre.getHours()) {
                      this.minDate.setDate(minDatePre.getDate() + 1)
                      this.minDate.setHours(0)
                      this.minDate.setMinutes(0)
                      this.order.schedule.datetime = this.minDate
                      console.log('preOrder more than endHour',this.minDate)
                      this.checkBusinessHour(this.minDate)
                    }
                  }
                } else if (minDatePre < startDate){
                  console.log('minDate is less than startDate',minDatePre)
                  if (minDatePre.getMonth() < startDate.getMonth()){
                    this.minDate.setMonth(startDate.getMonth())
                  }
                  this.minDate.setDate(startDate.getDate())
                  this.minDate.setHours(0)
                  this.minDate.setMinutes(0)
                  this.order.schedule.datetime = this.minDate
                  console.log('Mindate after date validation => ', this.minDate)
                  this.checkBusinessHour(this.minDate)
                } else {
                  this.$toast('The Pre Order product is not available anymore')
                }
              } else if (good.preOrder.istime == 2){
                let startDate = new Date(good.preOrder.startdate * 1000);
                let endDate = new Date(good.preOrder.enddate * 1000);
                console.log('Item date ', startDate , ' - ' , endDate)
                if (startDate <= minDatePre && endDate >= minDatePre){
                  console.log('minDate is in date range of array',minDatePre)
                } else if (minDatePre < startDate){
                  if (minDatePre.getMonth() < startDate.getMonth()){
                    this.minDate.setMonth(startDate.getMonth())
                  }
                  this.minDate.setDate(startDate.getDate())
                  this.minDate.setHours(0)
                  this.minDate.setMinutes(0)
                  this.order.schedule.datetime = this.minDate
                  console.log('Mindate after date validation => ', this.minDate)
                  this.checkBusinessHour(this.minDate)
                } else {
                  this.$toast('The Pre Order product is not available anymore')
                }
              } else if (good.preOrder.istime == 3){
                if (good.preOrder.begintime != "" || good.preOrder.endtime != ""){
                  console.log('Item time ',good.preOrder.begintime , ' - ' , good.preOrder.endtime)
                  let startHour = Number(good.preOrder.begintime.substring(0,2))
                  let endHour = Number(good.preOrder.endtime.substring(0,2))
                  let startMin = Number(good.preOrder.begintime.substring(3,5))
                  let endMin = Number(good.preOrder.endtime.substring(3,5))
                  console.log('start Hour => ',startHour , ' start Minute => ',startMin, ' end Hour => ',endHour, ' end Minute ',endMin)
                  if (startHour <= minDatePre.getHours() && endHour >= minDatePre.getHours()){
                    if (startHour == minDatePre.getHours() && startMin > minDatePre.getMinutes()){
                      this.minDate.setMinutes(startMin)
                      this.order.schedule.datetime = this.minDate
                      console.log('minDate after minute validation', this.minDate)
                      this.checkBusinessHour(this.minDate)
                    } else if (endHour == minDatePre.getHours() && endMin < minDatePre.getMinutes()){
                      this.minDate.setDate(minDatePre.getDate() + 1)
                      this.minDate.setHours(0)
                      this.minDate.setMinutes(0)
                      this.order.schedule.datetime = this.minDate
                      console.log('minDate after minute validation',this.minDate)
                      this.checkBusinessHour(this.minDate)
                    } else {
                      console.log('preOrder is in hour time range',minDatePre)
                    }
                  } else if (startHour > minDatePre.getHours()) {
                    this.minDate.setHours(startHour)
                    this.minDate.setMinutes(startMin)
                    this.order.schedule.datetime = this.minDate
                    console.log('preOrder less than startHour',this.minDate)
                    this.checkBusinessHour(this.minDate)
                  } else if (endHour < minDatePre.getHours()) {
                    this.minDate.setDate(minDatePre.getDate() + 1)
                    this.minDate.setHours(0)
                    this.minDate.setMinutes(0)
                    this.order.schedule.datetime = this.minDate
                    console.log('preOrder more than endHour',this.minDate)
                    this.checkBusinessHour(this.minDate)
                  }
                }
              }
            } else {
              this.minDate.setDate((minDatePre.getDate())+1)
              this.minDate.setHours(0)
              this.minDate.setMinutes(0)
              this.order.schedule.datetime = this.minDate
              this.checkBusinessHour(this.minDate)
            }
          }
        })
        return this.order.schedule.datetime = this.minDate
    },
        getDaysNumber(stringKey) {
        if (stringKey == 'SUNDAY'){
            return 0;
        } else if (stringKey == 'MONDAY'){
            return 1;
        } else if (stringKey == 'TUESDAY'){
            return 2;
        } else if (stringKey == 'WEDNESDAY'){
            return 3;
        } else if (stringKey == 'THURSDAY'){
            return 4;
        } else if (stringKey == 'FRIDAY'){
            return 5;
        } else if (stringKey == 'SATURDAY'){
            return 6;
        }
        },
        getDays(stringKey) {
        if (stringKey == 0){
            return 'SUNDAY';
        } else if (stringKey == 1){
            return 'MONDAY';
        } else if (stringKey == 2){
            return 'TUESDAY';
        } else if (stringKey == 3){
            return 'WEDNESDAY';
        } else if (stringKey == 4){
            return 'THURSDAY';
        } else if (stringKey == 5){
            return 'FRIDAY';
        } else if (stringKey == 6){
            return 'SATURDAY';
        }
        },
        confirmFn(schedule_datetime) {
        this.order.schedule.datetime = schedule_datetime;
        this.resolveDateTime();

        const time1 = (new Date()).getTime(), time2 = this.order.schedule.datetime.getTime(), ftime = (time2 - time1) / 1000 / 60;
        // console.log('time1 now',time1)
        // console.log('time2 select',time2)
        // console.log('ftime',ftime)

        if(this.order.schedule.type) {
            this.resolveDateTime();
        }

        this.showDishDatetime = false
        },
        cancelFn() {
        this.showDishDatetime = false
        },
        resolveDateTime() {
            let selectedDateTime = this.order.schedule.datetime;
            console.log('selectedDateTime',selectedDateTime)
            
            if(this.order.schedule.type && selectedDateTime.getMinutes()%10 > 0) {
                this.order.schedule.datetime.setMinutes(selectedDateTime.getMinutes() + (10-(selectedDateTime.getMinutes()%10)));
                selectedDateTime = this.order.schedule.datetime;
            }

            selectedDateTime.setSeconds(0);
            this.order.schedule.datetime = selectedDateTime;
            this.dish_datetime = moment(this.order.schedule.datetime, 'YYYY-MM-DD').format('YYYY-MM-DD HH:mm');
            console.log('dish_datetime>>>', this.dish_datetime);
        },
        get_data() {
        this.getApiData()
        },
        getApiData() {
        //处理返回来的数据
        const todo = cartindex => {
            const tempcart = cartindex && cartindex.cart.map(item => {
            let itemFinalPrice = item.marketprice
            if (item.isspecial) {
                if (parseInt(item.isspecial) == 2) {
                itemFinalPrice = item.price
                }
            }
            const tempItem = {
                detail: {
                thumb: item.thumb,
                title: item.title,
                },
                name: item.title,
                options: [item.optionname],
                qty: item.total,
                price: itemFinalPrice
            }
          if (item.preparation_time >= 60){
            tempItem.preparation_time_display = item.preparation_time_display
          }
          tempItem.preOrder = {
              ispre_order: item.ispre_order,
              preorderItem: item.preorderItem,
              counts: item.counts,
              istime: item.istime,
              week: item.week,
              startdate: item.startdate,
              enddate: item.enddate,
              weekStr: item.weekStr,
              startdateStr: item.startdateStr,
              enddateStr: item.enddateStr,
              begintime: item.begintime,
              endtime: item.endtime,
              begintimeStr: item.begintimeStr,
              endtimeStr: item.endtimeStr,
              fullWeek: item.fullWeek,
              days: item.days
          }
            return tempItem
            })

            this.goodsList = tempcart

            this.table = {
            title: cartindex.table.title,
            promo: cartindex.store.promo || '',
            tel: cartindex.store.tel,
            table: cartindex.table,
            tablezones: cartindex.tablezones,
            }
            console.log('>>> table >>>', this.table);

            this.store1.title = cartindex.store.title;
            this.store1.logo = cartindex.store.logo;
            this.store1.tel = cartindex.store.tel;
            this.store1.readyInMinute = cartindex.store.food_preparation_time;
            this.store1.location.address = cartindex.store.address;
            this.store1.is_rest = cartindex.store.is_rest;
            this.store1.is_show = cartindex.store.is_show;
            this.store1.is_schedule = cartindex.store.is_schedule;
            this.store1.is_24_hours_operation = cartindex.store.is_24_hours_operation
            this.store1.location.lat = cartindex.store.lat;
            this.store1.location.lng = cartindex.store.lng;
            console.log('visible realname ==>>',cartindex.store.visiable_realname)
            console.log('visible phone ==>>',cartindex.store.visiable_phone)
            console.log('visible email ==>>',cartindex.store.visiable_email)
            this.store1.isNameRequired = true
            this.store1.isContactRequired = true
            //this.store1.isEmailRequired = true
            this.store1.isEpointEnabled = cartindex.store.pos_status && cartindex.store.pos_name==='epoint'? true:false;


            this.cart.summmary = cartindex.summmary
            this.cartTotal = cartindex.cartTotal || '0.00'
        }
        const takeawayUser = () => {
            //如果已登录并且是 takeaway 时，自动填写名称和电话
            if (this.sso.is_login && this.sso.user_info && this.sso.user_info.firstName) {
            if (this.isTakeaway || this.isDelivery) {
                this.isLogin = this.sso.is_login || false
                this.receiver_name = this.sso.user_info.firstName + ' ' + this.sso.user_info.lastName
                this.receiver_phone = this.sso.user_info.mobileNumber || ''
            }
            }
        }

            const actname = 'wapmenu'
            const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'wapmenu', 'orderid': 0 })
            cartPage('/app/index.php', queryParams).then(res => {
            // console.log('wapmenu response>>>', res);
            const cartindex = res.data
            if (cartindex.wapmenu_type && cartindex.wapmenu_type == 'new_page') {
                window.location.href = cartindex.forward_url
            } else {
                this.isTakeaway = cartindex.isTakeaway || false
                this.isDelivery = cartindex.isDelivery || false
                this.isSchedule = cartindex.isSchedule || false
                this.lalamove = cartindex.lalamove || false
                this.scheduleType = cartindex.scheduleType || false
                this.sso = cartindex.sso || {}
                this.businessHours = cartindex.businessHours || {}
                this.holiday = cartindex.holiday || {}
                this.payMethod = cartindex.payMethod || {}
                if (this.isDelivery) {
                const current_delivery_address = cartindex.current_delivery_address || false
                this.saveCurrentStoreInfo(this.store1)
                if (current_delivery_address) {
                    this.saveCurrentAddress(current_delivery_address) //如何用户已选择了地址，返回的时候，要把已选择地址覆盖vuex中的地址
                }
                }
                this.is_required_address_takeaway = cartindex.store.is_required_address_takeaway == 1 ? true : false

                takeawayUser && takeawayUser()
                if (cartindex.cart && cartindex.cart.length) {
                this.carts =  cartindex.cart
                cartindex && todo && todo(cartindex)
                setTimeout(() => {
                    this.isRequest = true
                }, 100)
                } else {
                // console.log('购物车为空，返回首页');
                queryParams["do"] = 'waplist'
                const url = { path: '/', query: queryParams }
                this.$router.push(url)
                }
            }

            if (this.scheduleType){
                this.order.schedule.type = true
                this.showtimeSchedule = true
            } else {
                this.order.schedule.type = false
            }
            this.isScheduleEnabled();

            if (sessionStorage.getItem('select_time')) {
                this.ShowTimeSchedule()
            }
            
            }).catch((error) => {
            console.log('====>error', error)
            })
        },
        cleanCoupon() {
        this.coupon_code = ''
        this.cart.summmary.promo.text = 0
        },
        applyCoupon() {
        this.isCoupon = this.coupon_code == 'save10'
        this.cart.summmary.promo.text = 0
        if (this.isCoupon)
            this.cart.summmary.promo.text = -10

        this.popupCoupon = false
        },
        validation(){
        this.isLoading = true
        console.log('validation..datetime', this.order.schedule.datetime)
        const getRouteQuery = () => {
        let tempParams = this.$route.query
        if (tempParams.h5api == undefined) {
            tempParams["h5api"] = 'on'
        }
        tempParams["do"] = 'validateBusinessAndHoliday' 
        return tempParams
        }
        const updateOption = () => {
        const queryParams = Object.assign(getRouteQuery(), {optype: 'businessAndHoliday', schedule_type: this.order.schedule.type});
        console.log('queryParams takeaway.vue', queryParams)
        validateBusinessAndHoliday("/app/index.php", queryParams)
                .then(res => {
                console.log('Res data takeaway.vue', res.data)
                this.indexPage = res.data
                this.storeInfo = this.indexPage.store
                this.businessHours = this.indexPage.businessHours
                this.holiday = this.indexPage.holiday
                console.log('This store data from php ,takeaway.vue ', this.storeInfo)
                let storeAvailable = false;
								let pre_order = true;
                let orderTime = this.parseTimezone(this.order.schedule.datetime)
                let hourOrder = orderTime.getHours().toString().padStart(2,'0') + orderTime.getMinutes().toString().padStart(2,'0')
                let dateOrder = orderTime.toISOString().slice(0,10)
                let dayOrder = this.getDays(orderTime.getDay())
                console.log('Day order scheduled ',dayOrder)

                for (let i in this.businessHours.data){
                    for (let j in this.businessHours.data[i]){
                    for (let k in this.businessHours.data[i][j]){
                        if (dayOrder == j){
                        let hourStartBusinessString = this.businessHours.data[i][j][k]['start'].toString().padStart(4,'0')
                        let hourEndBusinessString = this.businessHours.data[i][j][k]['end'].toString().padStart(4,'0')
                        let hourStartBusiness = Number(hourStartBusinessString)
                        let hourEndBusiness = Number(hourEndBusinessString)
                        if (hourOrder >= hourStartBusiness && hourOrder <= hourEndBusiness){
                            storeAvailable = true;
                            console.log('In operation hours')
                            break;
                        } else {
                            storeAvailable = false;
                            console.log('Not in operation hours')
                        }
                        }
                    }
                    }
                }

                for (let i in this.holiday.data){
                    for (let j in this.holiday.data[i]){
                    for (let k in this.holiday.data[i][j]){
                        if (j == dateOrder){
                        let hourStartHolidayString = this.holiday.data[i][j][k]['start'].toString().padStart(4,'0')
                        let hourEndHolidayString = this.holiday.data[i][j][k]['end'].toString().padStart(4,'0')
                        let hourStartHoliday = Number(hourStartHolidayString)
                        let hourEndHoliday = Number(hourEndHolidayString)
                        console.log('Hour Holiday to validate ', hourStartHoliday + ' and ',hourEndHoliday)
                        if (hourOrder >= hourStartHoliday && hourOrder <= hourEndHoliday){
                            storeAvailable = false;
                        }
                        }
                    }
                    }
                }

              for (let i in this.goodsList){
                if (this.goodsList[i].preOrder.ispre_order == 1){
                  if (!this.goodsList[i].preOrder.week.includes(orderTime.getDay())){
                      pre_order = false;
                  } else {
                    let startDate = new Date(this.goodsList[i].preOrder.startdate * 1000);
                    let endDate = new Date(this.goodsList[i].preOrder.enddate * 1000);
                    if (this.goodsList[i].preOrder.begintime != "" || this.goodsList[i].preOrder.endtime != ""){
                      var startHourVal = Number(this.goodsList[i].preOrder.begintime.toString().substring(0,5).replace(":",""));
                      var endHourVal = Number(this.goodsList[i].preOrder.endtime.toString().substring(0,5).replace(":",""));
                      console.log('startHour => ',startHourVal , ' endHour => ',endHourVal);
                    }
                    if (this.goodsList[i].preOrder.istime == 1){
                      if (startDate <= orderTime && endDate >= orderTime){
                        if (this.goodsList[i].preOrder.begintime != "" || this.goodsList[i].preOrder.endtime != ""){
                          if (startHourVal <= Number(hourOrder) && endHourVal >= Number(hourOrder)){
                            console.log('in hour range for pre order product')
                          } else {
                            pre_order = false;
                          }
                        }
                      } else {
                        pre_order = false;
                      }
                    } else if (this.goodsList[i].preOrder.istime == 2){
                      if (startDate <= orderTime && endDate >= orderTime){
                        console.log('in date range for pre order product')
                      } else {
                        pre_order = false;
                      }
                    } else if (this.goodsList[i].preOrder.istime == 3){
                      if (this.goodsList[i].preOrder.begintime != "" || this.goodsList[i].preOrder.endtime != ""){
                        if (startHourVal <= Number(hourOrder) && endHourVal >= Number(hourOrder)){
                          console.log('in hour range for pre order product')
                        } else {
                          pre_order = false;
                        }
                      }
                    }
                  }
                } else {
                  continue;
                }
              }

                console.log('Store is available after validation ',storeAvailable)

                if (!this.isSubmit) {
                    let currentDateTime = new Date();
                    let dishDateTime= new Date(Date.parse(this.dish_datetime))

                    let currentTime = currentDateTime.getTime()
                    let dishtime = dishDateTime.getTime()
                    let ftime = (dishtime - currentTime) / 1000 / 60;
                    console.log('current time',currentTime)
                    console.log('select time',dishtime)
                    console.log('diff time',ftime)

                    if (!this.isTermsAccepted) {
                    this.$toast(`Please agree to ${FASTORDER_MY} terms & conditions and privacy policy before placing the order.`)
                    } else if (this.store1.isNameRequired && !this.receiver_name) {
                    // this.$toast('The name is required!')
                    this.clearTime && clearTimeout(this.clearTime)
                    this.showWarning('name')
                    this.$refs.receiver_name.focus()
                    } else if (this.store1.isContactRequired && !this.receiver_phone) {
                    // this.$toast('The mobile phone number is required!')
                    this.clearTime && clearTimeout(this.clearTime)
                    this.showWarning('phone')
                    this.$refs.receiver_phone.focus()
                    } 
                    else if(this.store1.isContactRequired && this.receiver_phone && !this.isMobileValid){
                        this.showWarning('invalid number')
												// this.$toast('Invalid Mobile Number format. Please enter a valid mobile phone.')
												this.$refs.receiver_phone.focus()
                    }
                    /*else if (this.store1.isEmailRequired && !this.email) {
                    this.$toast('The email is required!')
                    this.$refs.email.focus()
                    }*/ else if (this.is_required_address_takeaway && !this.receiver_addr1) {
                    this.$toast('The address 1 is required!')
                    this.$refs.receiver_addr1.focus()
                    }else if(this.order.schedule.type && currentDateTime.getDate() == dishDateTime.getDate() && ftime <0){
                        this.$toast('Oops, time is not available, please select time again')
                    } 
                    else if (this.order.schedule.type && this.order.schedule.datetime == '') {
                    this.$toast('Oops, something wrong with your date & time for your advanced order.')
                    } else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type && storeAvailable == false) {
                    this.$toast('Merchant is not operating during the scheduled datetime, please try again another time!')
                    }  else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type && pre_order == false) {
											this.$toast('Cannot accept order out of pre order product time range, please try again another time!')
										} else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type == false && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
                    this.$toast("Merchant is not operating, please try again later!")
										} else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type == false && pre_order == false) {
											this.$toast('Cannot accept order out of pre order product time range, please try again another time!')
										} else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type && pre_order == false) {
												this.$toast("Cannot accept order out of pre order product time range, please try again another time!")
										} else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
												this.$toast("Cannot accept order out of operation hour, please try again another time!")
										} else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type == false && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
											this.$toast("Merchant is not operating, please try again later!")
										} else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type == false && pre_order == false) {
											this.$toast("Cannot accept order out of pre order product time range, please try again later!")
										} else if (this.order.schedule.type && this.order.schedule.datetime == '') {
											this.$toast('Oops, something wrong with your date & time for your advanced order.')
										} else if (this.storeInfo.is_24_hours_operation == 1 && this.order.schedule.type && storeAvailable == false) {
											this.$toast('Merchant is not operating during the scheduled datetime, please try again another time!')
										} else if (this.storeInfo.is_24_hours_operation == 0 && this.order.schedule.type && storeAvailable == false) {
                        this.$toast("Merchant is not operating during the scheduled datetime, please try again another time!")
                    } else if (this.storeInfo.is_24_hours_operation == 0 && this.storeInfo.is_rest != 1 || this.storeInfo.is_show != 1) {
                    this.$toast("Merchant is not operating, please try again later!")
                    } else {
                    this.placeorder(this.storeInfo)
                    }
                }
                })
                .catch(error => {
                // console.log('添加到购物车.error', error);
                }).finally(()=>{
                  this.isLoading = false
                });
        };
        updateOption();
        },
        async placeorder(storeInfo) {
        this.show = false;

        if(!this.order.schedule.type) {
            this.order.schedule.datetime = new Date();
            this.resolveDateTime();
        }

        console.log('pre-check store during placeorder>>>', this.store);
        console.log('pre-check order during placeorder>>>', this.order);
        console.log('pre-check table during placeorder>>>', this.table);

        const strApiName = '/app/index.php'
        const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'checkHistoryExist', 'mobile': this.receiver_phone })
        const apiRes = await checkHistoryExist(strApiName, queryParams)
        const { from_user, isTakeaway, has_sso_login, has_history_order } = apiRes.data
                    
        //有历史订单直接提交
        if (storeInfo.is_rest == 1 && storeInfo.is_show == 1){
            if (isTakeaway && has_history_order) {
            this.confirmPlaceOrder();
            } else {
            // 没有历史订单弹出窗口确认
            this.show = true
            }
        } else if (storeInfo.is_24_hours_operation == 1){
            if (isTakeaway && has_history_order) {
            this.confirmPlaceOrder();
            } else {
            // 没有历史订单弹出窗口确认
            this.show = true
            }
        }
        },
        confirmPlaceOrder() {
        if (!this.isSubmit) {
            this.show = false
            this.isSubmit = true
            this.isRequest = true
            
            this.order.user.name= this.receiver_name;
            this.order.user.contact= this.receiver_phone;
            this.order.user.email= this.email;
            this.order.address = undefined;
            
            console.log('this.order>>>', this.order);
        }
        },
        confirmOrder() {
        this.overlay= true  

        const queryParams = this.getUrlParams({ 'h5api': 'on', 'do': 'addtoorder' })
        const postData = {
            type: 'add',
            total: this.cartTotal,
            ordertype: 1,
            address: 'undefined',
            receiver_name: this.order.user.name,
            receiver_phone: this.order.user.contact,
            email: this.order.user.email,
            isnew_phone: this.checkbox_mobile_value,
            is_tc: this.isTermsAccepted,
            sex: 1,
            tables: queryParams.tablesid || 0,
            order_id: 0,
            couponid: 0,
            meal_time: '',
            dispatcharea: '',
            schedule_type: this.order.schedule.type,
            dish_datetime: this.parseTimezone(this.order.schedule.datetime),
            membership_id: this.membership_id,
            receiver_addr1: this.receiver_addr1 || '',
            receiver_addr2: this.receiver_addr2 || '',
            receiver_addr3: this.receiver_addr3 || '',
            counts: 0,
            remark: this.order.remark
        }
        // Object.keys(postData).forEach(key => {
        //   queryParams[key] = postData[key]
        // })

        if (this.payMethod.is_redirect == 1) {
            postData.payment_channel = this.payMethod.choosedChannel;
        }

        const strApiName = '/app/index.php?' + this.parseParams(queryParams)
        addToOrder(strApiName, postData).then(res => {
            if (res.type == 'ajax' || res.type == 'json') {
            const strUrl = (res.redirect != '' && res.message == '') ? res.redirect : res.data.orderDetailUrl
            window.location.href = strUrl
            } else {
            this.$toast(res.message || 'request network error1')
            this.isSubmit = false
            this.isRequest = true
            }
        }).catch((error) => {
            console.log('网络错误', error);
            this.isSubmit = false
            this.isRequest = true
            this.$toast({
            message: 'request network error',
            onClose: () => {
                // queryParams.do = 'waplist'
                // const url = { path: '/', query: queryParams }
                // this.$router.push(url)
            }
            })
        }).finally(()=>{ 
            this.overlay= false
        });
        },
        cancelOrder() {
        this.isSubmit=false;
        console.log('cancel submit...>>>', this.isSubmit);
        },
        noChangeit() {
        if (!this.isSubmit) {
            this.show = false
            this.$refs.receiver_phone.focus()
        }
        },
        parseParams(data) {
        try {
            var tempArr = [];
            for (var i in data) {
            var key = encodeURIComponent(i);
            var value = encodeURIComponent(data[i]);
            tempArr.push(key + '=' + value);
            }
            var urlParamsStr = tempArr.join('&');
            return urlParamsStr;
        } catch (err) {
            return '';
        }
        },
        evtLogout(option) {
        this.isLogin = option.isLogin
        this.receiver_name = ''
        this.receiver_phone = ''
        },
        funTC(strLink) {
        window.open(strLink, '_blank')
        },
        userAddressList() {
        console.log(['检查登录状态', this.user_islogin, this.user_detail]);

        if (this.user_islogin) {
            this.receiver_phone = this.user_detail.mobileNumber
        }
        if (this.receiver_phone != '') {
            if (this.user_islogin) {
            this.$router.push({ path: '/user/addressList', query: { mobile: this.receiver_phone } })
            } else {
            const url = {
                path: "/user/addressDetail",
                query: { mobile: this.receiver_phone, "address_id": 0 }
            };
            this.$router.push(url);
            }
        } else {
            this.$toast('Please insert mobile number.')
        }
        }
    }
}

</script>
<style lang="less" scoped>
@import url("../../assets/css/global.less");
@import url('../../assets/css/common.less');

.shopping-cart-summary{
    position:fixed;
    bottom:0;z-index:100;
    width: 100%;
}
.cart-summary{
    display: block;
    background-color: @fff;
    margin: 10px 0px 0;
    font-family: roboto;
}
.cart-summary_close{
    display:none
}
.cart-summary-confirm-order{
    z-index:1005;
    background-color:@fff;
}
.cart-summary-form{
    // border-top:6px solid @main;
    // border-radius:3px 3px 0 0;
    // padding-top:5px
}
.cart-summary-form-name_text{
    font-size:14px;
    width:80px;
    margin-right:10px;
}
.cart-summary-form-name_input{
    background-color:@fff !important;
    text-align:left;
    font-size:13px;
    flex:1;
    height:24px
}
.cart-summary-warning-wrapper{
    position: relative;
}
.cart-summary-form-name{
    // background-color:@fff !important;
}
.cart-summary-form-contact{
    // background-color:@fff !important;
}
.cart-summary-form-contact_text{
    font-size:14px;
    width:80px;
    margin-right:10px;
}
.cart-summary-form-email{
    background-color:@fff;
}
.cart-summary-form-email_text{
    font-size:14px;
    width:80px;
    margin-right:10px;
}
.cart-summary-form-email_input{
    background-color:@fff !important;
    text-align:left;
    font-size:13px;
    flex:1;
    height:24px
}

.cart-summary-form-notice{
    border:1px solid @main;
}

.user-nav-name {
    background-color: @white4;
    .schedule-item {
        font-size: 12px;
    }
    .user-nav-name-label {
        padding: 0;
        margin: 2px 0 2px 0;
        font-size: 14px;
        flex-basis: 80px;
    }
    .user-nav-name-value {
        text-align: right;
        font-size: 12px;
    }
    .warning-error{
        padding:3px 5px;
        animation: outline 1s infinite alternate;
        @keyframes outline{
        0% {
            outline: 1px solid @fff;
            outline-offset: 0px;
            }
        100% {
            outline: 1px solid @red;
            outline-offset: 0px;
            box-shadow: 0 0 6px 0px @red;
            }
        }
    }
    .warning-success{
        padding:3px 5px;
        // outline: 1px solid rgb(76 175 80);
        // box-shadow: 0 0 3px 0px rgb(76 175 80);
        }

    .inputfocus {
        padding: 2px 5px;
        border: 0px;
    }
    .inputfocus:focus {
        box-shadow: 0 0px 5px 0px hsla(191, 84%, 64%, 0.35),
        -10px 10px 10px 10px hsla(0, 0%, 100%, 0.5);
    }
    .contact-phone {
        border: 0px;
        text-align: left;
        font-size: 12px;
        > input.vti__input {
        text-align: left;
        }
        >.v-application ul{
            padding:0;
        }
        .vti__dropdown-list{
            max-width:250px !important;
            z-index:1000 !important;
            padding:0 !important;
        }
    }
}
.checkbox-mobile-label {
    padding: 1px 0;
    font-size: 13px;
    .linkcolor {
        color: @blue1;
    }
}
.import_text1 {
    font-weight: bold;
    display: contents;
    font-size: 12px;
}
.import_text2 {
    font-weight: bold;
    display: contents;
    font-size: 12px;
}



.cart-takeaway{
    position:relative;
    background-color: @rgb-Color2;
    padding: 16px 0px 16px 15px;
    box-shadow: 0 1px 0px 0px @rgb-Color4;

    span{
        font-family: roboto;
        font-size: 12px;
        font-weight: 600;
    }
    .pre-order{
        animation: move 2s infinite normal ease-in-out;
        color:@fff;
        background-color:@yellow1;
        border-radius: 2px;
        padding:2px 5px;
        font-family: roboto;
        font-size: 14px;
        font-weight: 900;
    }
    @keyframes move {
        0% {
            transform: translateX(-2px);
        }
        50% {
            transform: translateX(2px);
        }
        100% {
            transform: translateX(-2px);
        }
    }
}
.cart-takeaway-header-wrapper{
    display:flex;
    align-items:center;
    font-family:roboto;
    font-weight:600;
}
.cart-takeaway-header-text{
    font-size:14px;
    color:@main;
    font-weight:500;
}
.cart-takeaway-header-text-small{
    font-size:13px;
    color:@main;
}
.cart-takeaway-btn-back--text{
    font-size:12px;
    color:@main;
}
.cart-takeaway-schedule-wrapper{
    display:flex;
    position: relative;
}
.cart-takeaway-select-time{
    position:static;
    transition: 0.3s ease-in;
    transform: translateX(0)
}
.cart-takeaway-select-time__isActive{
    transform: translateX(-120%);
    position:absolute;
    top:0;
}

.cart-takeaway-select-time-btn{
    cursor:pointer;
    width:100%;
}
.cart-takeaway-select-time-btn--text{
    background-color:@fff;
    width:300px;
    display:flex;
    align-items:center;
}
.cart-takeaway-select-time-btn--text_pre{
    color:@gray9;
}
.cart-takeaway-select-time-btn--text_now{
    color:@gray9;
}
.cart-takeaway-select-time-btn--icon{
    background-color:@main;
    display:grid;
    place-items:center;
    padding:0 5px
}
.cart-takeaway-time{
    z-index: 10;
    transform:translateX(120%);
    position:absolute;
    padding: 5px 0px 10px 0;
}

.cart-takeaway__isActive{
    position:static;
    transform:translateX(0);
    transition:0.3s ease-in;
}

.button-expand-detail{
    background-color:@main;
    font-weight:600;
    font-family:roboto;
    color:@fff;
    font-size:13px;
    display:flex;
    justify-content:center;
    align-items:center;
}
.button-expand-detail_active{
    border: none;
}

.expand-detail{
    transform:translateY(100%);
    position: absolute;
    z-index: -100;
    opacity: 0;
}
.expand-detail_active{
    transition: 0.3s linear;
    position: static;
    transform:translateY(0);
    z-index: 2;
    opacity: 1;
}

.button-expand-detail-icon{
    transition:0.3s ease-in;
    transform: rotate(0deg)
}
.button-expand-detail-icon_active{
    transform: rotate(180deg);
}


.cart-order_remark{
    height:50px;
    flex:1;
    display:flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 0px 0px @rgb-Color4;
    color:@main;
    font-weight:600;
}

.remark_active{
    width:100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding:20px 10px 20px 10px;
    min-height: 50px;
    height: 100%;
}
.show-remark{
    color:@gray9;
    margin-top:5px;
}
.show-remark-btn{
    display:flex;
    align-items:center;
}
.show-remark-textarea{
    width:335px;
    background-color:@rgb-Color2;
}
.show-remark-btn-save{
    display:block !important;
    margin-left:auto !important;
    margin-top:8px;
}

.cart-order-coupon{
    height:50px;
    flex:1;
    display:flex;
    justify-content: center;
    align-items: center;
    box-shadow: 1px 1px 0px 0px @rgb-Color4;
    color:@main;
    font-weight:600
}
.cart-order-coupon_active{
    width:100%;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    padding:10px 0px 0px 0px;
    min-height: 50px;
    height: 100%;
}
.order-coupon-btn{
    align-items:center;
}
.order-coupon-show{
    width:100%;
    background:@main;
}
.order-coupon-text{
    background-color:@white4 !important;
}

.terms-privacy{
    cursor: pointer;
    padding:5px 16px;
    border-bottom:1px solid @rgb-Color4;
    font-size: 12px;
    color: @gray8;
}
.terms-privacy-subhead{
    display:flex;
    justify-content:space-between;
}
.terms-privacy-content{
    padding:2px 0;
}
.terms-privacy-link{
    color: @blue1;
}

.cart-payment{
    padding: 10px 24px 6px;
    font-size: 14px;
}
.cart-payment-icon{
    transition: .2s ease-in;
}
.cart-payment-icon__isActive{
    transform: rotate(180deg);
}
.cart-payment-detail{
    padding: 10px 0;
    border-bottom: 1px solid @rgb-Color1;
}
.cart-checkout{
}
.cart-checkout-btn{
    width: 100%;
    padding: 10px;
    border-radius: 5px;
}
.cart-payment-header{
    padding-bottom:3px;
    border-bottom: 1px solid @white9;
}
.cart-payment-btn-dropdown{
    display:flex;
    align-items:center;
    color:@main;
    font-weight:600;
    cursor:pointer;
}
.cart-payment-total{
    padding:0 0 12px 0;
}
.cart-checkout-text{
    font-size:13px;
    font-family:roboto;
}

.confirm-phone-overlay-main{
    padding:20px;
    z-index:1010;
    background-color:@fff;
    height:220px;
    font-size:14px
}
.confirm-phone-overlay_receiver-phone{
    padding:20px 0;
    font-size:16px;
    font-weight:600;
}
.confirm-place-order{
    color:@main;
    font-weight:600;
    cursor:pointer;
}
.confirm-place-order-btn-save{
    color:@main;
    font-weight:600;
}

</style>
